import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[internalLinkNavigate]',
})
export class InternalNavigationDirective implements AfterViewInit, OnDestroy {
  removeListeners: (() => void)[] = [];
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.addAnchorEventListeners();
  }

  addAnchorEventListeners(): void {
    const htmlContent = this.el.nativeElement;

    if (htmlContent) {
      const anchors: HTMLAnchorElement[] = htmlContent.querySelectorAll('a');
      anchors.forEach((anchor: HTMLAnchorElement) => {
        const removeListener = this.renderer.listen(anchor, 'click', (event: MouseEvent) => {
          if (anchor.hash) {
            event.preventDefault();
            this.scrollToAnchor(anchor.hash);
          }
        });
        this.removeListeners.push(removeListener);
      });
    }
  }

  scrollToAnchor(hash: string): void {
    const target = hash.slice(1);
    const shadowRoot = this.el.nativeElement.shadowRoot || this.el.nativeElement;
    const targetElement = shadowRoot.querySelector(`#${target}`) || shadowRoot.querySelector(`[name="${target}"]`);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
  ngOnDestroy(): void {
    this.removeListeners.forEach((removeListener: () => void) => removeListener());
    this.removeListeners = [];
  }
}
